import React from "react"
import styled from "styled-components"
import { rem } from "polished"

import { media } from "@sr/common"
import { Accordion, SemiBdTitle3 } from "@sr/gatsby-theme-ui"

export interface HardwareCategoryFaqPropsShape {
  faq: {
    title: string
    _rawBody: string
  }[]
}

const HardwareCategoryFaq = ({ faq }: HardwareCategoryFaqPropsShape) => {
  const faqItems = faq.map((item, i: number) => {
    return {
      title: item.title,
      _rawContent: item._rawBody,
      id: i,
    }
  })

  return (
    <HardwareCategoryFaqStyled>
      <div className="hardware-category-faq-container">
        <SemiBdTitle3>Frequently Asked Questions</SemiBdTitle3>
        <Accordion
          items={faqItems}
          collapsible={true}
          defaultActiveItem={0}
          className="hardware-category-faq-accordion"
        />
      </div>
    </HardwareCategoryFaqStyled>
  )
}

export default HardwareCategoryFaq

const HardwareCategoryFaqStyled = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
  padding: ${rem(40)} ${rem(16)};

  @media ${media.midUp} {
    padding: ${rem(80)} ${rem(64)} 0;
  }

  @media ${media.stMidUp} {
    padding: ${rem(112)} 0 0;
  }

  .hardware-category-faq-container {
    @media ${media.midUp} {
      max-width: ${rem(616)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(952)};
    }

    h3 {
      @media ${media.midUp} {
        text-align: left;
        font-size: ${rem(40)};
        line-height: ${rem(48)};
      }

      @media ${media.stMidUp} {
        text-align: center;
      }
    }

    .hardware-category-faq-accordion {
      padding-top: ${rem(32)};

      .accordion-header__button {
        color: var(--color-gray800);
      }

      .accordion-group__header {
        .accordion-header__layout {
          font-size: ${rem(20)};
          line-height: ${rem(32)};
          font-weight: 600;
          text-align: left;

          @media ${media.midUp} {
            font-size: ${rem(24)};
            line-height: ${rem(32)};
          }
        }
      }

      .body-text {
        text-align: left;
      }
    }
  }
`
